<template lang="html">
    <div class="row bg-lightest pb-4">

        <!-- Left column -->
        <div class="col-md-6 pl-5">

            <div class="d-flex align-items-center mt-5">
                <span class="fs-largest bold mr-2">This campaign is for</span>
                <span>
                    <v-select :options="getPromocodeAudience" v-model="selectedAudience" @input="audinceChanged"></v-select>
                </span>
            </div>

            <div style="width: 300px;" class="mt-5 ml-4">

                <div class="d-flex flex-column">
                    <label for="code">Code</label>
                    <input name="code" type="text" class="" v-model="promocode.code" @input="$v.promocode.code.$touch"></input>
                    <div v-if="$v.promocode.code.$dirty">
                        <span v-if="!$v.promocode.code.required" class="fs-small color-6">Code is required</span>
                        <span v-if="!$v.promocode.code.minLength" class="fs-small color-6">Code must have at least {{$v.promocode.code.$params.minLength.min}} characters</span>
                    </div>
                </div>

                <div class="d-flex w-100 mt-3">
                    <div class="d-flex flex-column w-50 pr-1">
                        <label for="discount">{{discountLabel}}</label>
                        <div class="d-flex">
                            <input name="discount" type="number" class="glued-right" style="min-width: 0;" v-model="promocode.value" @input="$v.promocode.value.$touch"></input>
                            <v-select class="glued-left" style="width: 40px;" :options="getPercentageOrCurrency" v-model="selectedDiscountType" @input="discountTypeChanged" :disabled="true"></v-select>
                        </div>
                        <div v-if="$v.promocode.value.$dirty">
                            <span v-if="!$v.promocode.value.required" class="fs-small color-6">Required</span>
                        </div>
                    </div>
                    <div class="d-flex flex-column w-50 pl-1">
                        <label for="max">Máx. Quantity</label>
                        <input name="max" type="number" placeholder="E.g., 50" class="" v-model="promocode.maxQuantity" @input="$v.promocode.maxQuantity.$touch"></input>
                        <div v-if="$v.promocode.maxQuantity.$dirty">
                            <span v-if="!$v.promocode.maxQuantity.required" class="fs-small color-6">Required</span>
                        </div>
                    </div>
                </div>

                <div class="mt-3">

                    <!-- <checkbox v-model="promocode.applyToExtras">
                        Apply discount to extras
                    </checkbox> -->

                    <!-- <checkbox v-model="promocode.applyToPickups" :disabled="true">
                        Apply discount to pickups <span class="bold">(Soon)</span>
                    </checkbox> -->

                </div>
            </div>

        </div>

        <!-- Right column -->
        <div class="col-md-6">

            <!-- White Box -->
            <div class="col-sm-12 border-light mt-5 py-3">

                <div class="fs-large bold mb-3">Promocode is valid when booked between</div>

                <!-- Booking period -->
                <div class="d-flex align-items-center">

                    <date-picker-new
                        class="dateRangePicker"
                        v-model="bookingPeriod"
                        @input="bookingPeriodChanged($event)"
                        :range="true"
                        :enableClear="false"
                        :clearOutside="true"
                        :showFromTo="false">
                    </date-picker-new>

                    <span class="mx-3">and</span>

                </div>

                <!-- Valid -->
                <div class="d-flex align-items-center mt-3">
                    <span class="mr-3">
                        <v-select :searchable="false" :options="getPromocodeDaysInAdvance" v-model="selectedBookingBefore" @input="bookingBeforeChanged"></v-select>
                    </span>
                    <span>before activity start.</span>
                </div>

                <!-- Validation errors display -->
                <div class="d-flex flex-column" v-if="$v.promocode.bookingPeriodStart.$dirty">
                    <span v-if="!$v.promocode.bookingPeriodStart.required" class="fs-small color-6">Booking period start is Required</span>
                    <span v-if="!$v.promocode.bookingPeriodStart.lowerThanBookingPeriodFinish" class="fs-small color-6">Booking period start must be lower or equal to finish date</span>
                </div>
                <div class="d-flex flex-column" v-if="$v.promocode.bookingPeriodFinish.$dirty">
                    <span v-if="!$v.promocode.bookingPeriodFinish.required" class="fs-small color-6">Booking period end is Required</span>
                    <span v-if="!$v.promocode.bookingPeriodFinish.higherThanBookingPeriodStart" class="fs-small color-6">Booking period end must be higher or equal to start date</span>
                </div>

            </div>

            <!-- White Box -->
            <div class="col-sm-12 border-light mt-3 py-3">

                <div class="fs-large bold mb-3">For activities that happen between</div>

                <!-- Start valid period -->
                <div class="d-flex align-items-center">

                    <date-picker-new
                        class="dateRangePicker"
                        v-model="validPeriod"
                        @input="validPeriodFinishChanged($event)"
                        :range="true"
                        :enableClear="false"
                        :clearOutside="true"
                        :showFromTo="false">
                    </date-picker-new>

                </div>

                <!-- Week day picker -->
                <div class="d-flex pt-4 align-items-center">
                    <div class="d-flex flex-column">
                        <week-day-picker v-model="promocode.validDaysOfWeek" @change="$v.promocode.validDaysOfWeek.$touch"></week-day-picker>
                    </div>
                </div>

                <!-- Hour Interval selector -->
                <div v-if="haveValidHoursInterval == true" class="pt-4">
                    <label>
                        Starting hour is between:
                    </label>
                    <div class="d-flex align-items-center">

                        <!-- Hour Start -->
                        <div style="width: 95px;">
                            <timepicker
                                :defaultTime="validPeriodStartTime"
                                @change="validHourChanged($event, 'start')"
                                :disabled="false">
                            </timepicker>
                        </div>

                        <div class="mx-3">and</div>

                        <!-- Hour end -->
                        <div style="width: 95px;">
                                <timepicker
                                :defaultTime="validPeriodFinishTime"
                                @change="validHourChanged($event, 'finsh')"
                                :disabled="false">
                            </timepicker>
                        </div>

                    </div>

                    <div v-if="$v.promocode.validPeriodHourInterval.$dirty">
                        <span v-if="!$v.promocode.validPeriodHourInterval.isValid" class="fs-small color-6">Start hour must be before ending hour</span>
                    </div>
                </div>

                <!-- Validation errors display -->
                <div class="d-flex flex-column" v-if="$v.promocode.validPeriodStart.$dirty">
                    <span v-if="!$v.promocode.validPeriodStart.required" class="fs-small color-6">Start valid period is Required</span>
                    <span v-if="!$v.promocode.validPeriodStart.lowerThanValidPeriodFinish" class="fs-small color-6">Start valid period must be lower or equal to finish date</span>
                </div>
                <div class="d-flex flex-column" v-if="$v.promocode.validPeriodFinish.$dirty">
                    <span v-if="!$v.promocode.validPeriodFinish.required" class="fs-small color-6">End valid period is Required</span>
                    <span v-if="!$v.promocode.validPeriodFinish.higherThanValidPeriodStart" class="fs-small color-6">End valid period must be higher or equal to start date</span>
                </div>
                <div class="d-flex flex-column" v-if="$v.promocode.validDaysOfWeek.$dirty">
                    <span v-if="!$v.promocode.validDaysOfWeek.required" class="fs-small color-6">Select at least one day of the week</span>
                </div>

            </div>

            <!-- White Box -->
            <div class="col-sm-12 border-light mt-3 py-3">

                <!-- Radio options -->
                <div class="d-flex align-items-center">
                    <radio name="allProducts" v-model="promocode.isForAllProducts" @input="$v.promocode.products.$touch" :value="true" class="mr-3">
                        All Products
                    </radio>
                    <radio name="allProducts" v-model="promocode.isForAllProducts" @input="$v.promocode.products.$touch" :value="false">
                        Selected Products
                    </radio>
                    
                </div>

                <div v-if="promocode.isForAllProducts == true" class="mt-3 text-center p-4 dark">
                    All products will be on this promocode
                </div>

                <!-- Products -->
                <div v-else class="mt-3">

                    <!-- Product list -->
                    <div v-if="promocode.products.length > 0" class="d-flex flex-column">
                        <div v-for="(product, index) in promocode.products" :key="index" class="d-flex align-items-center mb-2">
                            <v-select class="openUp" :options="getProducts" v-model="promocode.products[index]" placeholder="Select a product" label="name"></v-select>
                            <i class="fas fa-trash-alt dark ml-3 pointer" @click="removeProduct(index)"></i>
                        </div>
                    </div>

                    <div v-else class="text-center p-2 dark">
                        Please add a product to this list
                    </div>

                    <!-- Add Btn -->
                    <div class="add d-flex align-items-center pointer fs-small bold mt-3" @click="addProduct">
                        <i class="ico-add fs-smallest add-circle color-1"></i> Add Product
                    </div>

                    <div v-if="$v.promocode.products.$dirty" class="mt-3">
                        <span v-if="!$v.promocode.products.validProduct" class="fs-small color-6">Select at least one product</span>
                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import DatePickerNew from 'vue-date'
import {mapGetters, mapActions} from 'vuex'
import vSelect from 'vue-select'
import VueDatepicker from 'vuejs-datepicker'
import WeekDayPicker from '@/components/inventory/products/components/WeekDayPicker'
import Timepicker from '@/tools/Timepicker'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
    data: function () {
        return {
            // promocode: null,
            selectedAudience: null,
            selectedDiscountType: null,
            selectedBookingBefore: null,
            bookingPeriod: [],
            validPeriod: [],
        }
    },
    props: {
        promocode: {
            type: Object,
            required: true
        },
    },
    validations: {
        promocode: {
            code: {
                required,
                minLength: minLength(4),
            },
            value: {
                required,
            },
            maxQuantity: {
                required,
            },
            bookingPeriodStart: {
                required,
                lowerThanBookingPeriodFinish: function () {
                    return this.validateBookingPeriodStart()
                }
            },
            bookingPeriodFinish: {
                required,
                higherThanBookingPeriodStart: function () {
                    return this.validateBookingPeriodFinish()
                }
            },
            validPeriodStart: {
                required,
                lowerThanValidPeriodFinish: function () {
                    return this.validateValidPeriodStart()
                }
            },
            validPeriodFinish: {
                required,
                higherThanValidPeriodStart: function () {
                    return this.validateValidPeriodFinish()
                }
            },
            validPeriodHourInterval: {
                isValid: function () {
                    return this.validatePeriodHourInterval()
                }
            },
            validDaysOfWeek: {
                required
            },
            products: {
                validProduct: function () {
                    return this.validProductSelction()
                }
            }
        }
    },
    created: function () {
        // only for development
        // this.promocode = this.getPromocodes[0]

        // set the correct dropdown values
        this.setStartingSelections()

        this.setStartingDates()

        // emits change so that the parent can acces the validation (e.v)
        this.emitChange()
    },
    computed: {
        ...mapGetters([
            'getPercentageOrCurrency',
            'getPromocodeAudience',
            'getPromocodeDaysInAdvance',
            'getProducts',
        ]),
        discountLabel: function () {
            return this.selectedAudience.id == 0? 'Discount' : 'Commission'
        },
        haveValidHoursInterval: function () {
            return typeof this.promocode.validPeriodStartTime != "undefined" && typeof this.promocode.validPeriodFinishTime != "undefined"
        },
        pickerDateFrom:{
            get: function(){
                return moment(this.dateFrom).format('YYYY-MM-DD')
            },
            set: function(value){
                this.dateFrom = moment(value)
            }
        },
        pickerDateTo:{
            get: function(){
                return moment(this.dateTo).format('YYYY-MM-DD')
            },
            set: function(value){
                this.dateTo = moment(value)
            }
        },
        validPeriodStartTime: function () {
            let startTimeArray = this.promocode.validPeriodStartTime.split(":")
            return [
                startTimeArray[0],
                startTimeArray[1]
            ]
        },
        validPeriodFinishTime: function () {
            let finishTimeArray = this.promocode.validPeriodFinishTime.split(":")
            return [
                finishTimeArray[0],
                finishTimeArray[1]
            ]
        },
    },
    methods:{
        bookingPeriodChanged: function (e) {
            this.promocode.bookingPeriodStart = e[0]
            this.promocode.bookingPeriodFinish = e[1]
            this.$v.promocode['bookingPeriodStart'].$touch()
            this.$v.promocode['bookingPeriodFinish'].$touch()
        },
        validPeriodFinishChanged: function (e) {
            this.promocode.validPeriodStart = e[0]
            this.promocode.validPeriodFinish = e[1]
            this.$v.promocode['validPeriodStart'].$touch()
            this.$v.promocode['validPeriodFinish'].$touch()
        },
        validateBookingPeriodStart: function () {
            return moment(this.promocode.bookingPeriodStart).isSameOrBefore(this.promocode.bookingPeriodFinish);
        },
        validateBookingPeriodFinish: function () {
            return moment(this.promocode.bookingPeriodFinish).isSameOrAfter(this.promocode.bookingPeriodStart);
        },
        validateValidPeriodStart: function () {
            return moment(this.promocode.validPeriodStart).isSameOrBefore(this.promocode.validPeriodFinish);
        },
        validateValidPeriodFinish: function () {
            return moment(this.promocode.validPeriodFinish).isSameOrAfter(this.promocode.validPeriodStart);
        },
        validatePeriodHourInterval: function () {

            // false = invalid
            if(typeof this.promocode.validPeriodStartTime == "undefined" && this.promocode.validPeriodFinishTime == "undefined"){
                return true
            } else {
                // Start Hour MUST be before finish hour
                return Date.parse('01/01/2011 '+this.promocode.validPeriodStartTime) < Date.parse('01/01/2011 '+this.promocode.validPeriodFinishTime)
            }
        },
        validHourChanged: function(e, type) {
            if(type == 'start'){
                this.promocode.validPeriodStartTime = e+':00'
            } else {
                this.promocode.validPeriodFinishTime = e+':00'
            }

            this.$v.promocode.validPeriodHourInterval.$touch()
        },
        validProductSelction: function() {
            if(this.promocode.isForAllProducts == true){
                return true
            } else {
                return this.promocode.products.length > 0
            }
        },
        setStartingSelections: function () {
            // set Tourist or Agent
            this.selectedAudience = this.getPromocodeAudience.find(audience => audience.id == this.promocode.promocodeType)

            // set time booked before
            this.selectedBookingBefore = this.getPromocodeDaysInAdvance.find(option => option.id == this.promocode.bookingDaysInAdvance)

            // set the correct discount type: € or %
            this.selectedDiscountType = this.getPercentageOrCurrency.find(type => type.id == this.promocode.amountType)
        },
        setStartingDates: function () {

            this.bookingPeriod[0] = this.promocode.bookingPeriodStart? moment(this.promocode.bookingPeriodStart).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
            this.bookingPeriod[1] = this.promocode.bookingPeriodFinish? moment(this.promocode.bookingPeriodFinish).format('YYYY-MM-DD') : moment().add(8, 'day').format('YYYY-MM-DD')
            this.promocode.bookingPeriodStart = this.bookingPeriod[0]
            this.promocode.bookingPeriodFinish = this.bookingPeriod[1]

            this.validPeriod[0] = this.promocode.validPeriodStart? moment(this.promocode.validPeriodStart).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
            this.validPeriod[1] = this.promocode.validPeriodFinish? moment(this.promocode.validPeriodFinish).format('YYYY-MM-DD') : moment().add(8, 'day').format('YYYY-MM-DD')
            this.promocode.validPeriodStart = this.validPeriod[0]
            this.promocode.validPeriodFinish = this.validPeriod[1]

        },
        audinceChanged: function (e) {
            this.promocode.promocodeType = e.id
        },
        bookingBeforeChanged: function (e) {
            this.promocode.bookingDaysInAdvance = e.id
        },
        discountTypeChanged: function (e) {
            this.promocode.amountType = e.id
        },
        customDateChanged: function (e, holder) {
            this.$set(this.promocode, holder, moment(e).format("YYYY-MM-DD HH:mm:ss"))
            this.$v.promocode[holder].$touch()
        },
        addProduct: function () {
            console.log('add product');
            this.promocode.products.push(this.getProducts[0])
        },
        removeProduct: function (index) {
            this.promocode.products.splice(index, 1)
        },
        emitChange: function () {
            this.$emit('change', {promocode: this.promocode, v:this.$v})
        }
    },
    components: {
        vSelect,
        VueDatepicker,
        WeekDayPicker,
        DatePickerNew,
        Timepicker
    },
    watch: {
        promocode: {
            handler: function(newVal, oldVal){
                this.emitChange()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// promocodeForm.vue?543ca112